import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["colorToken", "colorTokenArgs"];
import React from 'react';
import Shape from '@bubble-ui/primitive-shape';
import Surface from '@bubble-ui/primitive-surface';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { useDesignContext } from '@klarna/designtokens';
import defaultColorVariables from '@bubble-ui/particle-default-color-variables';
var Warning = _ref => {
  var {
      colorToken,
      colorTokenArgs
      /**
       * @deprecated props spreading for this component will be removed with v6.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var designContext = useDesignContext(defaultColorVariables);
  return /*#__PURE__*/React.createElement(Surface, _extends({
    height: 20,
    width: 20
  }, props), /*#__PURE__*/React.createElement(Shape, {
    d: "M5.44,9.186 C6.713,7.056 8.244,5.074 9.998,3.28 C11.752,5.074 13.283,7.056 14.557,9.186 C15.808,11.277 16.805,13.498 17.527,15.804 C12.741,17.534 7.252,17.534 2.47,15.804 C3.192,13.498 4.189,11.277 5.44,9.186 Z M8.9982,11.4973 L10.9982,11.4973 L10.9982,6.4973 L8.9982,6.4973 L8.9982,11.4973 Z M9.9983,12.4973 C9.1703,12.4973 8.4983,13.1693 8.4983,13.9973 C8.4983,14.8253 9.1703,15.4973 9.9983,15.4973 C10.8263,15.4973 11.4983,14.8253 11.4983,13.9973 C11.4983,13.1693 10.8263,12.4973 9.9983,12.4973 Z",
    fill: designContext.get(colorToken, colorTokenArgs).toString()
  }));
};
Warning.displayName = 'FeedbackStateIconWarning';
export default withProvisionalOverrideFromContext(Warning);
//# sourceMappingURL=index.js.map